import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';



@Injectable({
  providedIn: 'root'
})



export class DataService {

  /** @var Contains all imported data */
  private data = {};
  /** @var {boolean} Is champion data ready */
  private championDataReady = new Subject<any>();
  /** @var {any} The pen-window component */
  public penWindow: any;
  



  constructor(private httpClient: HttpClient) { 
    // Import champion data
    this.httpClient.get("https://ddragon.leagueoflegends.com/cdn/12.4.1/data/en_US/champion.json").subscribe((championData: {}) => {
      this.data['champion'] = championData['data'];
      this.championDataReady.next(true);
    });
  }



  /**
   * Retrieve imported champion data.
   * @return {{}} Data collection of all champion
   */
  public getChampionData(): {} {
    return this.data['champion'];
  }

  /**
   * This method announces when champion data is ready to be served.
   */
  public observeChampionData(): Observable<any> {
    return this.championDataReady.asObservable();
  }

  public getPenWindow(): any {
    return this.penWindow;
  }

}
